module.exports = __webpack_public_path__ + "static/img/menage2.79e87306.png";